import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'use-intl';

import { useSearchParams } from '@/lib/compat/navigation';
import { ResetPasswordContent } from '@/screens/reset-password/ResetPasswordContent';
import { InvalidResetToken } from '@/screens/reset-password/InvalidResetToken';

export const Route = createFileRoute('/_app/reset-password/')({
  component: ResetPasswordRoute,
});

function LoadingSpinner() {
  const t = useTranslations('auth');
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">{t('loading')}</p>
      </div>
    </div>
  );
}

function ResetPasswordRoute() {
  const sp = useSearchParams();
  const t = useTranslations('auth.invalidResetToken');
  const token = sp.get('token') ?? undefined;

  if (!token) {
    return <InvalidResetToken message={t('noToken')} />;
  }

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <ResetPasswordContent token={token} />
    </Suspense>
  );
}
